import script from "./MoleculeCompanyModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeCompanyModal.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeCompanyModal.vue?vue&type=style&index=0&id=2fb1efaa&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fb1efaa"]])

export default __exports__